import { Injectable } from '@angular/core';
import { SupportedProcessorSettingsService } from '@apps/portal/src/app/services/supported-processor-settings.service';
import { SelectInputKeysFilter, SelectInputsList } from '@portal/shared/helpers/src';
import { TranslationsKeyValue } from '@portal/shared/helpers/src/lib/create-list-from-inputs/interfaces/translations-key-value.interface';
import { ISelectInput } from '@portal/shared/ui/filter/src';
import { Features } from 'environments/enums/features.enum';
import { WalletType } from '../../../enums/wallet-type.enum';
import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';

@Injectable()
export class WalletList extends SelectInputsList {
  list: ISelectInput[];
  keyValue = this.selectInputKeysFilter.filterByFeature(
    {
      [WalletType.ApplePay]: 'Apple Pay',
      [WalletType.GooglePay]: 'Google Pay',
      [WalletType.MobilePayEcom]: 'MobilePay',
      [WalletType.VippsEcom]: 'Vipps',
      [WalletType.Atomicwallet]: 'Atomic Wallet',
      [WalletType.Bitcoincom]: 'Bitcoin.com',
      [WalletType.Bitfinexoffchain]: 'Bitfinex',
      [WalletType.Bitpay]: 'BitPay',
      [WalletType.Bitstampoffchain]: 'Bitstamp',
      [WalletType.Blockchainwallet]: 'Blockchain',
      [WalletType.Bravebrowser]: 'Brave',
      [WalletType.Brdwallet]: 'BRD',
      [WalletType.Coinbase]: 'Coinbase Exchange',
      [WalletType.Coinbaseapp]: 'Coinbase',
      [WalletType.Coinbasewallet]: 'Coinbase Wallet',
      [WalletType.Coinomi]: 'Coinomi',
      [WalletType.Copay]: 'Copay',
      [WalletType.Edgewallet]: 'edge',
      [WalletType.Electroncash]: 'Electron Cash',
      [WalletType.Electrumwallet]: 'Electrum',
      [WalletType.Enjinwallet]: 'Enjin Wallet',
      [WalletType.Exoduswallet]: 'Exodus',
      [WalletType.Geminioffchain]: 'Gemini',
      [WalletType.Kraken]: 'Kraken',
      [WalletType.Krakenoffchain]: 'Kraken Exchange',
      [WalletType.Kucoinoffchain]: 'KuCoin',
      [WalletType.Ledgerwallet]: 'Ledger',
      [WalletType.Metamask]: 'Metamask',
      [WalletType.Myceliumwallet]: 'Mycelium',
      [WalletType.Trezorwallet]: 'TREZOR',
      [WalletType.Trustwallet]: 'Trust Wallet',
      [WalletType.UndeterminedMobileWallet]: 'Undetermined Mobile',
    },
    {
      [Features.Crypto]: [
        WalletType.Atomicwallet,
        WalletType.Bitcoincom,
        WalletType.Bitfinexoffchain,
        WalletType.Bitpay,
        WalletType.Bitstampoffchain,
        WalletType.Blockchainwallet,
        WalletType.Bravebrowser,
        WalletType.Brdwallet,
        WalletType.Coinbase,
        WalletType.Coinbaseapp,
        WalletType.Coinbasewallet,
        WalletType.Coinomi,
        WalletType.Copay,
        WalletType.Edgewallet,
        WalletType.Electroncash,
        WalletType.Electrumwallet,
        WalletType.Enjinwallet,
        WalletType.Exoduswallet,
        WalletType.Geminioffchain,
        WalletType.Kraken,
        WalletType.Krakenoffchain,
        WalletType.Kucoinoffchain,
        WalletType.Ledgerwallet,
        WalletType.Metamask,
        WalletType.Myceliumwallet,
        WalletType.Trezorwallet,
        WalletType.Trustwallet,
        WalletType.UndeterminedMobileWallet,
      ],
    },
  );
  constructor(
    private selectInputKeysFilter: SelectInputKeysFilter,
    private supportedProcessorSettingsService: SupportedProcessorSettingsService,
  ) {
    super();
    this.getSortedList();
  }
  getSupportedWallets(): ISelectInput[] {
    const supportedProcessorSettings =
      this.supportedProcessorSettingsService.getSupportedProcessorSettingsFromSessionStorage();
    if (supportedProcessorSettings?.walletsSupported?.length) {
      const supportedWallets: TranslationsKeyValue = {};
      supportedProcessorSettings.walletsSupported.forEach((wallet) => {
        if (wallet === WalletType.ApplePayInApp || wallet === WalletType.ApplePayWeb) {
          supportedWallets[WalletType.ApplePay] = this.keyValue[WalletType.ApplePay];
        } else {
          supportedWallets[wallet] = this.keyValue[wallet] || wallet;
        }
      });
      this.getSortedList(supportedWallets);
    }
    return this.list;
  }

  getSortedList(wallets = this.keyValue): void {
    const inputs = this.getSelectInputs(wallets);
    const uniqueInputs = uniqBy(inputs, 'text');
    this.list = sortBy(uniqueInputs, (item: ISelectInput) => item.text.toLowerCase());
  }
}
